import { render } from "./TenantEdit.vue?vue&type=template&id=5dfaf7ef&scoped=true"
import script from "./TenantEdit.vue?vue&type=script&lang=js"
export * from "./TenantEdit.vue?vue&type=script&lang=js"

import "./TenantEdit.vue?vue&type=style&index=0&id=5dfaf7ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfaf7ef"]])

export default __exports__